/* 對戰數據（v0.5.1.1）：一場結束時兩隊每位武將的最終狀態，給後台的平衡分析用。
 * 連線由伺服器自己擷取；單機練習由瀏覽器擷取後跟著 econ/practice 回報（伺服器再檢查一次，見 server/matchlog.ts）。 */
// @ts-nocheck — 與 sim.ts 同一套動態物件
import { SG } from './sg.ts';

// h：真人座位（連線中途改由電腦代打的也算真人；單機只有自己）
SG.matchBoard = (w) => w.heroes().map((u) => ({
  tm: u.team, hero: u.spec.id, h: u.isPlayer || u.human || u.pid != null ? 1 : 0, lv: u.lv, k: u.kills, d: u.deaths, a: u.assists,
  it: u.items.map((it) => (it ? it.id : 0)), ml: u.ml || null,
  dmgHero: Math.round(u.stat ? u.stat.dmgHero : 0), taken: Math.round(u.stat ? u.stat.taken : 0), dmgBld: Math.round(u.stat ? u.stat.dmgBld : 0), heal: Math.round(u.stat ? u.stat.heal : 0),
}));
